import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";

const GoogleAdsenseForMobileOptions = [
    { label: '사용합니다.', value: '0' },
    { label: '사용하지 않습니다.', value: '1' }
]

class GoogleAdsenseForMobileForm extends Component {

    validate(setting) {
        return ((setting.adsenseMobileType === 'above' && setting.adsenseMobileAd1)
            || (setting.adsenseMobileType === 'below' && setting.adsenseMobileAd2)
            || (setting.adsenseMobileType === 'both' && setting.adsenseMobileAd1 && setting.adsenseMobileAd2))
    }

    componentDidMount() {
        const { onChange } = this.props
        onChange(
            Object.assign({},  this.props.data, {
                validated: this.validate(this.props.data.setting)
            })
        )
    }

    @autobind
    handleADTypeChange(ADType) {
        const { onChange } = this.props
        let setting = Object.assign({},  this.props.data.setting, {
            adsenseMobileType: ADType
        })
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleADCodeChange(type, ADCode) {
        const { onChange } = this.props
        var newObject = Object();
        newObject[type] = ADCode;
        let setting = Object.assign({},  this.props.data.setting, newObject)
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleSelect(item) {
        const { onChange } = this.props
        let setting = Object.assign({}, this.props.data.setting, {
            isRemoveAdsenseCode: item.value,

        })
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin8">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_plugin">
                    <div className="item_set item_sub">
                        본문에 직접 삽입한 애드센스 광고를 모바일에서
                        <TSelectForm className="opt_set opt_plugin1" items={GoogleAdsenseForMobileOptions} selected={data.setting.isRemoveAdsenseCode} onSelect={this.handleSelect} />
                    </div>
                </div>
                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            광고 배치 유형 중에 1 가지를 선택해주세요.
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            광고 코드 입력창에 애드센스 광고 코드를 넣어주세요.
                            <a href="https://www.google.com/adsense/app?hl=ko" target="_blank" className="link_other">애드센스
                                바로가기</a>
                        </li>
                        <li>
                            <span className="txt_em">3</span>
                            적용 버튼을 누르면 설정이 완료됩니다.
                        </li>
                    </ol>
                    <span className="txt_other">모바일 웹 레이아웃 변경 시 광고 위치가 바뀔 수 있습니다.</span>
                </div>
                <fieldset>
                    <legend className="tit_set">광고 형태</legend>
                    <div className="list_google">
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adsenseMobileType == "above"} onChange={(e)=>this.handleADTypeChange('above')}/>
                            <span className="ico_google ico_google3">상단 전체</span>
                        </label>
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adsenseMobileType == "below"} onChange={(e)=>this.handleADTypeChange('below')}/>
                            <span className="ico_google ico_google5">하단 전체</span>
                        </label>
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adsenseMobileType == "both"} onChange={(e)=>this.handleADTypeChange('both')}/>
                            <span className="ico_google ico_google8">상단, 하단 전체</span>
                        </label>
                    </div>
                    {(data.setting.adsenseMobileType == "above"||data.setting.adsenseMobileType == "both")&&(
                        <textarea className="tf_blog" title="광고 코드 입력"
                                  placeholder="320x50,320x100,300x250 - 모바일 배너' 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('adsenseMobileAd1', e.target.value)}>{data.setting.adsenseMobileAd1}</textarea>
                    )}
                    {(data.setting.adsenseMobileType == "below"||data.setting.adsenseMobileType == "both")&&(
                        <textarea className="tf_blog" title="광고 코드 입력"
                                  placeholder="320x50,320x100,300x250 - 모바일 배너' 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('adsenseMobileAd2', e.target.value)}>{data.setting.adsenseMobileAd2}</textarea>
                    )}
                </fieldset>
                {this.props.saveButton()}
            </div>
        )
    }
}

GoogleAdsenseForMobileForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default GoogleAdsenseForMobileForm
